import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
import Patients from "./pages/patients/Patients";
import Profile from "./pages/profile/Profile";
import Devices from "./pages/devices/Devices";
import Kits from "./pages/kits/Kits";
import Televisite from "./pages/televisite/Televisite";
import Telemonitoraggi from "./pages/telemonitoraggi/Telemonitoraggi";
import Doctors from "./pages/doctors/Doctors";
import Security from "./pages/security/Security";
import ControlRoom from "./pages/controlroom/ControlRoom";
import NotFound from "./pages/notfound/NotFound";
import Login from "./pages/login/Login";
import Layout from "./components/Layout";
import Users from "./pages/users/Users";
import Communications from "./pages/communications/Communications";
import { AuthProvider, useAuthUser } from "react-auth-kit";
import ProtectedRoute from "./components/ProtectedRoute";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import AxiosInterceptor from "./utils/AxiosInterceptor";
import H3KB from "./pages/H3KB/H3KB";
import axiosInstance from "./utils/AxiosInstance";
import DailyReports from "./pages/dailyreports/DailyReports";
import MonitorAlert from "./pages/monitoralert/MonitorAlert";
import { ToastContainer } from "react-toastify";
import ResetPassword from "./pages/resetpassword/ResetPassword";

function RequireRole(props) {
  const authUser = useAuthUser();

  let roleNeeded = props.roleNeeded;

  if (roleNeeded >= authUser()?.role) {
    return props.children;
  }

  return <Navigate to="/" replace />;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  dayjs.extend(utc);

  return (
    <div id="app" style={({ height: "100vh" }, { display: "flex" })}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider
          authType={"cookie"}
          authName={"_auth"}
          cookieDomain={window.location.hostname}
          cookieSecure={false}
        >
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route
                    path="/patients"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <Patients />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/televisite"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <Televisite />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/telemonitoraggi"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <Telemonitoraggi />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <Profile />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/security"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <Security />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <Users />
                        </RequireRole>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/communications"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <Communications />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/monitoralert"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <MonitorAlert />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/doctors"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <Doctors />
                        </RequireRole>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/controlroom"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <ControlRoom />
                        </RequireRole>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/devices"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <RequireRole roleNeeded={3}>
                          <Devices filter={null} />
                        </RequireRole>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/kits"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <RequireRole roleNeeded={3}>
                          <Kits />
                        </RequireRole>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/h3kb"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <H3KB />
                        </RequireRole>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dailyreports"
                    element={
                      <ProtectedRoute loginPath={"/login"}>
                        <DailyReports />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/login" element={<Login />} />
                  <Route path="/resetpassword" element={<ResetPassword />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <ReactQueryDevtools initialIsOpen={true} />
          </QueryClientProvider>
        </AuthProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
